<template>
  <div class="home">
    <span>
      <Icon iconClass="arrow-down" />
      <p>arrow-down</p>
    </span>
    <span>
      <Icon iconClass="arrow-left" />
      <p>arrow-left</p>
    </span>
    <span>
      <Icon iconClass="arrow-left2" />
      <p>arrow-left2</p>
    </span>
    <span>
      <Icon iconClass="arrow-right" />
      <p>arrow-right</p>
    </span>
    <span>
      <Icon iconClass="arrow-up" />
      <p>arrow-up</p>
    </span>
    <span>
      <Icon iconClass="backer" />
      <p>backer</p>
    </span>
    <span>
      <Icon iconClass="candle" />
      <p>candle</p>
    </span>
    <span>
      <Icon iconClass="candle-o" />
      <p>candle-o</p>
    </span>
    <span>
      <Icon iconClass="circle-picture" />
      <p>circle-picture</p>
    </span>
    <span>
      <Icon iconClass="circle-text" />
      <p>circle-text</p>
    </span>
    <span>
      <Icon iconClass="clock" />
      <p>clock</p>
    </span>
    <span>
      <Icon iconClass="close" />
      <p>close</p>
    </span>
    <span>
      <Icon iconClass="close-round" />
      <p>close-round</p>
    </span>
    <span>
      <Icon iconClass="comment" />
      <p>comment</p>
    </span>
    <span>
      <Icon iconClass="list" />
      <p>list</p>
    </span>
    <span>
      <Icon iconClass="listen" />
      <p>listen</p>
    </span>
    <span>
      <Icon iconClass="live" />
      <p>live</p>
    </span>
    <span>
      <Icon iconClass="locate" />
      <p>locate</p>
    </span>
    <span>
      <Icon iconClass="mail" />
      <p>mail</p>
    </span>
    <span>
      <Icon iconClass="menu" />
      <p>menu</p>
    </span>
    <span>
      <Icon iconClass="msg" />
      <p>msg</p>
    </span>
    <span>
      <Icon iconClass="organizer" />
      <p>organizer</p>
    </span>
    <span>
      <Icon iconClass="phone" />
      <p>phone</p>
    </span>
    <span>
      <Icon iconClass="play" />
      <p>play</p>
    </span>
    <span>
      <Icon iconClass="praise" />
      <p>praise</p>
    </span>
    <span>
      <Icon iconClass="praise-o" />
      <p>praise-o</p>
    </span>
    <span>
      <Icon iconClass="pray" />
      <p>pray</p>
    </span>
    <span>
      <Icon iconClass="pray-o" />
      <p>pray-o</p>
    </span>
    <span>
      <Icon iconClass="prize" />
      <p>prize</p>
    </span>
    <span>
      <Icon iconClass="replay" />
      <p>replay</p>
    </span>
    <span>
      <Icon iconClass="selection" />
      <p>selection</p>
    </span>
    <span>
      <Icon iconClass="share" />
      <p>share</p>
    </span>
    <span>
      <Icon iconClass="sponsor" />
      <p>sponsor</p>
    </span>
    <span>
      <Icon iconClass="star" />
      <p>star</p>
    </span>
    <span>
      <Icon iconClass="star-o" />
      <p>star-o</p>
    </span>
    <span>
      <Icon iconClass="text" />
      <p>text</p>
    </span>
    <span>
      <Icon iconClass="time" />
      <p>time</p>
    </span>
    <span>
      <Icon iconClass="users" />
      <p>users</p>
    </span>
    <span>
      <Icon iconClass="vote" />
      <p>vote</p>
    </span>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  span {
    float: left;
    display: inline-block;
    width: 120px;
    height: 120px;
    padding: 10px;
    border: 1px dashed #bebebe;
    text-align: center;
    .tj-svg-icon {
      color: #bebebe;
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>